import { type Column } from '@tanstack/react-table';
import Skeleton from '@/app/components/feedback/Skeleton';
import { type DataTableColumnMeta } from '../core/DataTableColumnMeta';

// Acima disso o esqueleto passa da altura da tela e só alonga a página.
const SKELETON_ROW_LIMIT = 10;
// Larguras alternadas entre linhas, para o esqueleto não parecer uma grade.
const CELL_WIDTHS = ['80%', '55%', '70%', '45%'];
const CHECKBOX_SIZE = 18;

type DataTableSkeletonRowsProps = {
  columns: Column<object>[];
  pageSize: number;
  showIndexColumn: boolean;
};

const skeletonAlignClass = (meta?: DataTableColumnMeta): string | undefined => {
  if (meta?.align === 'right') return 'ms-auto';
  if (meta?.align === 'center') return 'mx-auto';
  return undefined;
};

/** Linhas que ocupam o lugar dos registros na primeira carga, com as colunas reais da tabela. */
const DataTableSkeletonRows = ({ columns, pageSize, showIndexColumn }: DataTableSkeletonRowsProps) => {
  const skeletonRowCount = Math.min(pageSize, SKELETON_ROW_LIMIT);
  const rowNumbers = Array.from({ length: skeletonRowCount }, (_, rowIndex) => rowIndex);

  return (
    <tbody aria-hidden="true">
      {rowNumbers.map((rowNumber) => (
        <tr key={rowNumber}>
          {showIndexColumn ? (
            <td className="ek-table__index">
              <Skeleton width={16} />
            </td>
          ) : null}
          {columns.map((column, columnIndex) => {
            const meta: DataTableColumnMeta | undefined = column.columnDef.meta;
            const isSelectColumn = column.id === 'select';
            const textWidth = CELL_WIDTHS[(rowNumber + columnIndex) % CELL_WIDTHS.length];
            const width = isSelectColumn ? CHECKBOX_SIZE : textWidth;
            const height = isSelectColumn ? CHECKBOX_SIZE : undefined;
            return (
              <td key={column.id} className={meta?.className}>
                <Skeleton className={skeletonAlignClass(meta)} height={height} width={width} />
              </td>
            );
          })}
        </tr>
      ))}
    </tbody>
  );
};

export default DataTableSkeletonRows;
